import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/404.css';
import image from '../assets/images/404.png';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="notfound-page">
      <div className="notfound-container">
        <img src={image} alt="pagina no encontrada" className='containerimage'/>
        <h1>Ooops! página no encontrada</h1>
        <h2>Lo sentimos mucho, parece que la página a la que intentas acceder no existe</h2>
        <div className='buttoncontainer'>
          <button 
            type="button" 
            className="login-button"
            onClick={handleGoHome}
          >
            Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;

